import { type NameType, type Payload, type ValueType } from 'recharts/types/component/DefaultTooltipContent';
import { type TooltipContentProps } from 'recharts/types/component/Tooltip';

import { Flex } from '@/components/common/Flex';
import { Text } from '@/components/common/Text';

import styles from './Tooltip.module.scss';

export const Tooltip = (props: TooltipContentProps<ValueType, NameType>) => {
  const { payload } = props;

  const point: Payload<ValueType, NameType> | undefined = payload.at(0);

  if (!point) {
    return null;
  }

  const color =
    point.color ??
    (typeof point.payload === 'object' &&
    point.payload &&
    'color' in point.payload &&
    typeof point.payload.color === 'string'
      ? `var(--${point.payload.color})`
      : undefined);

  return (
    <Flex className={styles.root}>
      <Text
        type="medium16"
        style={{
          color: typeof point.dataKey === 'string' ? `var(--${point.dataKey}-color, ${color})` : color,
        }}
      >
        {point.value}
      </Text>
    </Flex>
  );
};
